function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import DEFAULT_OPTIONS, { EVENTS } from './core/options';
import METHODS from './core/methods';
import MODULES from './core/modules';
import bindEvents from './core/events';
import { isPlainObject, isImg, isString, isNumber, isElementExist, getElement, setStyle, isPercentage, roundToTwo } from './shared/utils';
import { NAME, CLASS_CONTAINER, CLASS_WRAPPER, CLASS_IMAGE } from './shared/constants';
var Zoomist = /*#__PURE__*/function () {
  /**
   * 
   * @param {Element} element - target element 
   * @param {Object} options - the configuration options
   */
  function Zoomist(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Zoomist);
    if (!element) throw new Error('The first argument is required.');
    if (!isElementExist(element)) throw new Error('This element is not exist.');
    this.element = getElement(element);
    this.options = Object.assign({}, DEFAULT_OPTIONS, isPlainObject(options) && options);
    this.init();
  }
  _createClass(Zoomist, [{
    key: "init",
    value: function init() {
      var element = this.element,
        options = this.options;
      var src = options.src;
      if (element[NAME]) return;
      element[NAME] = this;
      var source = options.src = isString(src) || isImg(src) ? src : DEFAULT_OPTIONS.src;
      var url = isImg(source) ? source.src : element.getAttribute(source);
      if (!url) throw new Error("Cannot find src from ".concat(source));
      this.create(url);
    }
  }, {
    key: "create",
    value: function create(url) {
      if (!url) return;
      var options = this.options;
      this.url = url;
      this.data = {};
      this.ratio = 1;
      this.__events__ = EVENTS;
      if (options.on) {
        for (var _i = 0, _Object$entries = Object.entries(options.on); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            k = _Object$entries$_i[0],
            v = _Object$entries$_i[1];
          this.__events__[k] = [v];
        }
      }
      this.mount();
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this = this;
      if (this.mounted) return;
      var element = this.element,
        options = this.options,
        data = this.data,
        url = this.url;
      var fill = options.fill,
        maxRatio = options.maxRatio,
        height = options.height;
      if (this.wrapper) this.wrapper.remove();
      var wrapper = document.createElement('div');
      wrapper.classList.add(CLASS_WRAPPER);
      var image = document.createElement('img');
      image.classList.add(CLASS_IMAGE);
      image.src = url;
      image.onload = function () {
        _this.wrapper = wrapper;
        _this.image = image;
        var naturalWidth = image.naturalWidth,
          naturalHeight = image.naturalHeight;
        var imageRatio = naturalWidth / naturalHeight;

        // set container height
        if (height) {
          setStyle(element, {
            width: '100%'
          });
          if (height === 'auto') setStyle(element, {
            paddingBottom: "".concat(roundToTwo(naturalHeight / naturalWidth * 100), "%")
          });else if (isNumber(height)) setStyle(element, {
            height: height
          });else if (isPercentage(height)) setStyle(element, {
            paddingBottom: height
          });
        }
        var offsetWidth = element.offsetWidth,
          offsetHeight = element.offsetHeight;
        _this.data.containerData = {
          width: offsetWidth,
          height: offsetHeight,
          aspectRatio: offsetWidth / offsetHeight
        };

        // get base on width or height
        var containerData = data.containerData;
        var baseSide;
        if (fill !== 'cover' && fill !== 'contain' && fill !== 'none') options.fill = 'cover';
        if (options.fill !== 'contain') baseSide = containerData.aspectRatio === imageRatio ? 'both' : containerData.aspectRatio > imageRatio ? 'width' : 'height';
        if (options.fill === 'contain') baseSide = containerData.aspectRatio === imageRatio ? 'both' : containerData.aspectRatio > imageRatio ? 'height' : 'width';

        // calculate the image width, height, left, top
        var imageWidth = options.fill === 'none' ? naturalWidth : baseSide === 'both' || baseSide === 'width' ? containerData.width : containerData.height * imageRatio;
        var imageHeight = options.fill === 'none' ? naturalHeight : baseSide === 'both' || baseSide === 'height' ? containerData.height : containerData.width / imageRatio;
        var imageLeft = (containerData.width - imageWidth) / 2;
        var imageTop = (containerData.height - imageHeight) / 2;
        _this.data.originImageData = {
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight,
          aspectRatio: imageRatio,
          width: imageWidth,
          height: imageHeight,
          left: imageLeft,
          top: imageTop
        };
        _this.data.imageData = Object.assign({}, _this.data.originImageData);
        setStyle(image, {
          width: imageWidth,
          height: imageHeight,
          left: imageLeft,
          top: imageTop
        });

        // if has maxRatio
        if ((!isNumber(maxRatio) || maxRatio <= 1) && maxRatio !== false) options.maxRatio = false;
        bindEvents(_this);
        _this.mounted = true;
        _this.render();
      };
    }
  }, {
    key: "render",
    value: function render() {
      var element = this.element,
        wrapper = this.wrapper,
        image = this.image;
      element.classList.add(CLASS_CONTAINER);
      wrapper.append(image);
      element.append(wrapper);
      this.createModules();
      this.emit('ready');
    }
  }]);
  return Zoomist;
}();
Object.assign(Zoomist.prototype, METHODS, MODULES);
export default Zoomist;